// extracted by mini-css-extract-plugin
export default {"disabled":"CreateSavedView-module__disabled--HLIuj"};